import { FramingGeometry }    from '@tokamap/core';
import { MapFraming }         from '@tokamap/core';
import { MercatorPoint }      from '@tokamap/core';
import { FramingRect }        from '@tokamap/core';
import { shapesExtentPoints } from '@tokamap/core';
import currentEditorStore     from '@/TokamapEditor/stores/currentEditorStore';

const INSIDE_TOLERANCE = 0.005;

export type ShapeOutsideLimit = { id: string; points: MercatorPoint[] };

function insideRect(rect: FramingRect, rotationDeg: number) {
	const { center, width, height } = rect;
	const tolerance = Math.max(width, height) * INSIDE_TOLERANCE;
	const bearing = (-rotationDeg * Math.PI) / 180;
	const right: MercatorPoint = [Math.cos(bearing), -Math.sin(bearing)];
	const up: MercatorPoint = [Math.sin(bearing), Math.cos(bearing)];

	return ([x, y]: MercatorPoint) => {
		const dx = x - center[0];
		const dy = y - center[1];

		return Math.abs(dx * right[0] + dy * right[1]) <= width / 2 + tolerance
			&& Math.abs(dx * up[0] + dy * up[1]) <= height / 2 + tolerance;
	};
}

export function startFrameIsEmpty(framing: MapFraming, geometry: FramingGeometry): boolean {
	if (framing.start.mode !== 'frame' || !geometry.startRect) return false;

	const shapes = currentEditorStore.get.getAllShapes();
	const isInside = insideRect(geometry.startRect, framing.rotationDeg);

	return shapes.length > 0 && !shapes.some(shape => shapesExtentPoints([shape]).some(isInside));
}

export default function shapesOutsideLimit(framing: MapFraming, geometry: FramingGeometry): ShapeOutsideLimit[] {
	if (framing.limit.mode !== 'frame' || !geometry.limitRect) return [];

	const isInside = insideRect(geometry.limitRect, framing.rotationDeg);

	return currentEditorStore.get.getAllShapes()
		.map(shape => ({ id: shape.id, points: shapesExtentPoints([shape]).filter(point => !isInside(point)) }))
		.filter(shape => shape.points.length > 0);
}
